// src/hooks/useApi.js

import { useMutation, useQuery } from "@tanstack/react-query";

// Custom hook for fetching data
export const useFetchData = (queryKey, queryFunction, options) => {
  return useQuery({
    queryKey,
    queryFn: queryFunction,
    ...options,
    refetchOnWindowFocus: false,
  });
};
//Custom hook for deleting data
export const useDeleteData = queryFunction => {
  return useMutation({
    mutationFn: queryFunction,
  });
};

// Custom hook for posting data
export const usePostData = queryFunction => {
  return useMutation({
    mutationFn: queryFunction,
  });
};

// Custom hook for updating data (PUT request)
export const usePutData = queryFunction => {
  return useMutation({
    mutationFn: queryFunction,
  });
};
